export default __webpack_public_path__ + "static/img-tablet-d1949918f936a8cc41b262e7563d2db9.png";